import { Check } from 'lucide-react';
import { classNameList } from 'utils/property';
import { capitalize } from 'utils/string';
import styles from './Checkbox.module.scss';

interface IProps {
  label: string;
  checked?: boolean;
  onClick?: () => void;
}

export const Checkbox = ({ label, checked = false, onClick }: IProps): JSX.Element => {
  return (
    <div className={styles.checkbox}>
      <button
        className={classNameList(styles.checkboxContainer, checked ? styles.checkboxContainerChecked : '')}
        onClick={onClick}>
        <Check />
      </button>
      <button className={styles.checkboxLabel} onClick={onClick}>
        {capitalize(label.toLowerCase())}
      </button>
    </div>
  );
};
